/* src/app/invoice/setup/invoice-setup-filters-presenter/invoice-setup-filters-presenter.component.scss */
:host ::ng-deep .p-multiselect {
  width: 100%;
}
:host ::ng-deep .p-multiselect-label {
  min-width: 10em;
}
/*# sourceMappingURL=invoice-setup-filters-presenter.component.css.map */
